import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  hospitalID: null,
  selectedAppointmentId: null,
};

const physicianSlice = createSlice({
  name: "physican",
  initialState,
  reducers: {
    setHospitalID: (state, action) => {
      state.hospitalID = action.payload;
    },
    setSelectedAppointmentId(state, action) {
      state.selectedAppointmentId = action.payload;
    },
    clearSelectedAppointmentId(state) {
      state.selectedAppointmentId = null;
    },
  },
});

export const {
  setSelectedAppointmentId, clearSelectedAppointmentId
} = physicianSlice.actions;

export default physicianSlice.reducer;
